export const safeStringify = (value: unknown): string => {
  const seen = new WeakSet<object>();

  const replacer = (_key: string, val: unknown) => {
    if (typeof Element !== 'undefined' && val instanceof Element) {
      return `<${val.tagName.toLowerCase()}>`;
    }

    if (val instanceof Date) {
      return val.toISOString();
    }

    if (val instanceof Map) {
      return Object.fromEntries(val);
    }

    if (val instanceof Set) {
      return Array.from(val);
    }

    if (typeof val === 'function') {
      return `[Function ${val.name || 'anonymous'}]`;
    }

    if (typeof val === 'object' && val !== null) {
      const objectValue = val as object;
      if (seen.has(objectValue)) {
        return '[Circular]';
      }
      seen.add(objectValue);
    }

    return val;
  };

  try {
    return JSON.stringify(value, replacer, 2);
  } catch (error) {
    console.warn('safeStringify error', error, value);
    return '[Unserializable]';
  }
};
